import useSWR from "swr";
import { AiccPromptVariable } from "types/model/aiccPrompt";
import { AiccSandboxMode } from "constants/aiccPromptSandbox";
import * as sandboxAPI from "services/aiccPromptSandbox";
import { AICC_SWR_CONFIG } from "./swrConfig";

export function useAiccSandboxVariables(languageId: number | undefined, mode: AiccSandboxMode) {
  const { data, error, isLoading } = useSWR(
    languageId ? ["aicc/sandbox-variables", languageId, mode] : null,
    () => sandboxAPI.fetchAiccSandboxVariables(languageId as number, { mode }),
    AICC_SWR_CONFIG
  );

  return {
    variables: (data ?? []) as AiccPromptVariable[],
    isLoading,
    isError: !!error,
  };
}
